import { Component, OnInit, ViewChild } from "@angular/core";
import { MatMenuTrigger } from "@angular/material/menu";

@Component({
	selector: "app-notification",
	templateUrl: "./notification.component.html",
	styleUrls: ["./notification.component.css"]
})
export class NotificationComponent implements OnInit {
	NOTIFICATION = "../../../assets/icons/icon_noticication.svg";
	EMPTY_NOTIFICATION = "../../../assets/icons/Icon-feather-bell.svg";
	notifications: any[];
	iconPath: string = this.EMPTY_NOTIFICATION;
	@ViewChild(MatMenuTrigger) trigger: MatMenuTrigger;

	ngOnInit(): void {
		this.notification();
	}

	notification() {
		this.notifications = JSON.parse(localStorage.getItem("notification"));
		this.changeIcon();
	}

	addNotification(notification: string) {
		if (notification != null && notification.trim()) {
			var index = this.notifications.findIndex(i => i == notification);

			if (index == -1) {
				this.notifications.push(notification);
				var json = JSON.stringify(this.notifications);
				localStorage.setItem("notification", json);
			}
		}
		this.changeIcon();
	}

	changeIcon() {
		if (this.notifications.length > 0) {
			this.iconPath = this.NOTIFICATION;
		} else {
			this.iconPath = this.EMPTY_NOTIFICATION;
		}
	}

	closeNotification(value: number) {
		this.notifications.splice(value, 1);
		var json = JSON.stringify(this.notifications);
		localStorage.removeItem("notification");
		localStorage.setItem("notification", json);
		this.changeIcon();
	}

	show(e: Event) {
		if (this.notifications.length == 0) {
			this.trigger.closeMenu();
		}
	}
}
